import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

export default function VisitTracker() {
  const location = useLocation();
  useEffect(() => {
    api.post("/analytics/track", {
      path: location.pathname,
      referrer: document.referrer || "",
      user_agent: navigator.userAgent || "",
    }).catch(() => {});
  }, [location.pathname]);
  return null;
}
